import { useLocation, useNavigate } from 'react-router-dom';
import './coupon.css';
import { useContext, useState } from 'react';
import { cartContext } from '../../App';
import HeaderOther from '../ui/header-other';

export default function Coupon() {

    const { extraData, appliedCoupon, changeAppliedCoupon, CartItem } = useContext(cartContext);
    const [inputCoupon, setInputCoupon] = useState('');
    const [inValiCoupon, setInValidCoupon] = useState('');

    const orderValue = CartItem.reduce((sum, item) => sum + Math.round(item.details.price * (100 - item.details.discount) / 100)*item.qty, 0);
    

    const navigate = useNavigate();
    const location = useLocation();
    function back() {
        
        // Check if there is a navigation history within the app
        if (location.key !== 'default') {
            navigate(-1); // Go back to the previous page
        } else {
            navigate('/'); // Redirect to the home page
        }
    }

    function handleCoupon(code) {
        const findCoupon = extraData.data.coupon.find((item) => item.code.toLowerCase() === code.toLowerCase())
        if (findCoupon) {
            if (findCoupon.code === 'APP10') { 
                setInValidCoupon('Oops! This coupon is only valid on the app. Please download the app to use this coupon.')
            }
            else if (findCoupon.quantity < 1) {
                setInValidCoupon('Oops! This coupon has already been used. Try another one!')
            } else if (orderValue >= findCoupon.minOrderValue) {
                const discountPrice = Number(findCoupon.upto) > Math.round(orderValue*findCoupon.discount/100) ? Math.round(orderValue*findCoupon.discount/100): Number(findCoupon.upto)
                changeAppliedCoupon(findCoupon.code, discountPrice)
                navigate('/cart')
            } else if (orderValue < findCoupon.minOrderValue) {
                const invalidText = 'Minimum Order Value ₹' + findCoupon.minOrderValue + ' to Avail this Coupon !';
                setInValidCoupon(invalidText)
            }
        } else {
            setInValidCoupon('Oops! Coupon expired or invalid.')
        }
    }

    return (
        <>
            <HeaderOther title='Apply Coupon' description='' />
            <div style={{backgroundColor:'white', height:'100%'}}>
                <div style={{display:'flex', flexDirection:'row', justifyContent:'space-around', marginTop:'10px', alignItems:'center', height:'50px', margin:'10px'}}>
                    <input
                        type='text'
                        className='coupon-input'
                        placeholder='Enter Coupon Code'
                        value={inputCoupon}
                        onChange={(e) => setInputCoupon(e.target.value)}
                    />
                    <div className='coupon-apply-btn' onClick={() => handleCoupon(inputCoupon)}>
                        <p className='coupon-apply-text'>Apply</p>
                    </div>
                </div>
                {
                    inValiCoupon && <p style={{margin:'0 0 0 15px', color:'red', fontSize:'14px'}}>{inValiCoupon}</p>
                }
                <p style={{marginLeft:'15px', fontSize:'16px'}}>Coupons Available</p>
                {
                    extraData.data.coupon.map((item, index) => (

                        item.quantity > 0 && item.display &&
                            <div key={ index } style={{display:'flex', flexDirection:'row',justifyContent:'space-between', height:'120px', backgroundColor:'white', margin:'10px', borderRadius:'10px', alignItems:'center', boxShadow:'1px 1px 5px gray'}}>
                                <div className='coupon-percent-vertical'>
                                    <p className='coupon-percent-text'>{item.discount}% OFF</p>
                                </div>
                                <div style={{width:'100%'}}>
                                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', margin:'0px 10px'}}>
                                        <p style={{fontSize:'16px', margin:'5px 0'}}>{item.code}</p>
                                        <div onClick={() => handleCoupon(item.code)}><p style={{fontSize:'16px', margin:'5px 0', fontWeight:'bold', color:'#2c5f2d'}}>Apply</p></div>
                                    </div>
                                    <p style={{fontSize:'12px', margin:'10px', borderBottom:'0.15px dotted black', paddingBottom:'10px'}}>Get {item.discount}% off upto <span style={{fontFamily:'Arial'}}>&#8377;</span>{item.upto}.</p>
                                    <p style={{fontSize:'12px', margin:'10px'}}>Use Code {item.code} & get {item.discount}% off on orders above <span style={{fontFamily:'Arial'}}>&#8377;</span>{item.minOrderValue}.</p>
                                </div>
                            </div>
                    ))
                }
                {
                    extraData.data.coupon.every(coupon => coupon.display === false || (coupon.display && coupon.quantity <= 0)) &&
                    <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
                        <img src='/icons/coupon.png' alt='No Coupon Found' style={{height:'150px', width:'200px', objectFit: 'cover'}}/>
                        <p className='my-orders-heading' style={{ color: 'gray', margin: '10px', padding: '0' }}>No Coupons Available Right Now!</p>
                    </div>
                }
            </div>
        </>
    );
}


